import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface LabColumnHeaderParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface LabColumnHeader {
    id?: any;
    tenantId: any;
    branchId: any;  
    value:string;
    isActive:string;
    
    parameters?: LabColumnHeaderParameter[];
    links?: any;
}
export abstract class LabColumnHeaderData {    
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<LabColumnHeader[]>;
    abstract create(url: string, data: LabColumnHeader): Observable<LabColumnHeader[]>;
    abstract update(url: string, data: LabColumnHeader): Observable<LabColumnHeader>;
    abstract delete(url: string): Observable<any>;
}